import React from "react";
import styled from "styled-components";
import { EmailChangeForm } from "./emailChangeForm";
import { EmailVerificationForm } from "./emailVerificationForm";
import { LinkNumberForm } from "./LinkNumberForm";
import { PasswordResetForm } from "./passwordResetForm";
import { RecoveryEmailPage } from "./recoveryEmailPage";

interface FirebaseActionPageProps extends React.HTMLAttributes<HTMLDivElement> {
	mode: "resetPassword" | "verifyEmail" | "changeEmail" | "recoveryEmail" | "linkNumber";
	oobCode: string;
}

export const FirebaseActionPage: React.FC<FirebaseActionPageProps> = ({ oobCode, mode, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<LeftSide>
				<div>
					<div>
						{mode === "resetPassword" ? "🔐" : mode === "changeEmail" ? "📨" : mode === "linkNumber" ? "📞" : "🔎"}
					</div>
				</div>
			</LeftSide>
			<RightSide>
				{mode === "resetPassword" ? (
					<PasswordResetForm oobCode={oobCode} />
				) : mode === "changeEmail" ? (
					<EmailChangeForm oobCode={oobCode} />
				) : mode === "recoveryEmail" ? (
					<RecoveryEmailPage oobCode={oobCode} />
				) : (
					<EmailVerificationForm oobCode={oobCode} />
				)}
			</RightSide>
		</Container>
	);
};

// interfaceLinkNumberToAccountPage

export const LinkNumberToAccountPage: React.FC = () => {
	return (
		<Container>
			<LeftSide>
				<div>
					<div>📞</div>
				</div>
			</LeftSide>
			<RightSide>
				<LinkNumberForm />
			</RightSide>
		</Container>
	);
};

const Container = styled.div`
	flex: 1;
	display: flex;
`;

const LeftSide = styled.div`
	@media (max-width: 900px) {
		display: none;
	}
	background-color: ${({ theme }) => theme.colors.primary};
	user-select: none;
	flex: 1;
	max-width: 50vw;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 25vw;
		height: 25vw;
		border-radius: 13vw;
		background-color: ${({ theme }) => theme.colors.backgroundPrimary};
		font-size: 110px;
		line-height: 25vw;
		text-align: center;
	}
`;

const RightSide = styled.div`
	flex: 1;
	max-width: 50vw;
	background-color: ${({ theme }) => theme.colors.bodyBackground};
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 110px;
	> form {
		max-width: 320px;
	}

	@media (max-width: 900px) {
		max-width: 100%;
		padding: 30px;
		> form {
			max-width: initial;
			button {
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
`;
